import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {SiteClientUuid, SiteSummary} from '../models/shipping';

export const siteSummariesActionTypes = {
  LOAD: type('[Site Summaries] Load'),
  LOAD_FULL: type('[Site Full Summaries] Load'),
  LOAD_SUCCESS: type('[Site Summaries] Load Success'),
  LOAD_FAIL: type('[Site Summaries] Load Fail'),
  CLEAR: type('[Site Summaries] Clear')
};

export class LoadSiteSummariesAction implements Action {
  readonly type = siteSummariesActionTypes.LOAD;
  constructor(public payload?: SiteClientUuid) {}
}
export class LoadSiteFullSummariesAction implements Action {
  readonly type = siteSummariesActionTypes.LOAD_FULL;
  constructor(public payload?: SiteClientUuid) {}
}

export class LoadSiteSummariesSuccessAction implements Action {
  readonly type = siteSummariesActionTypes.LOAD_SUCCESS;
  constructor(public payload?: SiteSummary) {}
}

export class LoadSiteSummariesFailAction implements Action {
  readonly type = siteSummariesActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}

export class LoadSiteSummariesClearAction implements Action {
  readonly type = siteSummariesActionTypes.CLEAR;
  constructor() {}
}
